import React, { useEffect } from "react";

function Deconnexion() {
  useEffect(() => {
    localStorage.clear();
    window.location.replace("/login");
  }, []); // Pas de dépendance pour exécuter qu'une seule fois au montage

  return null; // Pas besoin de JSX dans ce composant
}

export default Deconnexion;
